import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { ModeProvider } from "./mode/ModeContext";
import { AuthProvider } from "./auth/AuthContext";
import { ProfileProvider } from "./profiles/ProfileContext";
import { captureReferralFromUrl } from "./lib/referral";
import { applyTheme, getTheme } from "./lib/theme";
import { App } from "./App";

// Re-apply the saved theme from app JS on every load. The inline <head> pre-paint
// script does this first to avoid a flash, but it can be deferred/stripped (e.g. by
// Cloudflare Rocket Loader) or lost to a stale cached index.html — so we re-apply here
// to guarantee the persisted light/dark choice always sticks across refreshes.
applyTheme(getTheme());

// Persist a `?ref=` code into the 3-month attribution cookie on any landing.
captureReferralFromUrl();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <ModeProvider>
        <AuthProvider>
          <ProfileProvider>
            <App />
          </ProfileProvider>
        </AuthProvider>
      </ModeProvider>
    </ErrorBoundary>
  </StrictMode>,
);
